"use strict";
/*
Copyright 2018 - 2022 The Alephium Authors
This file is part of the alephium project.

The library is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

The library is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with the library. If not, see <http://www.gnu.org/licenses/>.
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.base58ToBytes = exports.isBase58 = exports.bs58 = void 0;
/** This source is under MIT License and come originally from https://github.com/cryptocoinjs/bs58 **/
const base_x_1 = __importDefault(require("base-x"));
const error_1 = require("../error");
const ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
exports.bs58 = (0, base_x_1.default)(ALPHABET);
function isBase58(s) {
    if (s === '' || s.trim() === '') {
        return false;
    }
    try {
        return exports.bs58.encode(exports.bs58.decode(s)) === s;
    }
    catch (err) {
        return false;
    }
}
exports.isBase58 = isBase58;
function base58ToBytes(s) {
    try {
        return exports.bs58.decode(s);
    }
    catch (e) {
        throw new error_1.TraceableError(`Invalid base58 string ${s}`, e);
    }
}
exports.base58ToBytes = base58ToBytes;
exports.default = exports.bs58;
